import { FilteredClientAccount, TransactionTypesEnum } from '@shared/models';
import { FeatureToggleState } from '@store/reducers/feature/feature.reducer';
import { InternalTransferState } from '@store/reducers/internal-transfer/internal-transfer.reducer';

export const getInternalTransferOverviewNextPage = (): string => 'internal-transfer/triage';
export const getInternalTransferTriageNextPage = (): string => 'internal-transfer/summary';
export const getInternalTransferToNextPage = (internalTransfer: InternalTransferState): string => {
  return internalTransfer.transactionType === TransactionTypesEnum.NEW_ACCOUNT
    ? 'secure/internal-transfer/personal-info'
    : 'secure/internal-transfer/review';
};
export const getInternalTransferFromNextPage = (): string =>
  'secure/internal-transfer/holdings-review';

export const getInternalTransferDetailsNextPage = (): string =>
  'secure/internal-transfer/holdings-review';

export const getInternalTransferHoldingsReviewNextPage = (
  eligibleInternalTransferToAccounts: FilteredClientAccount,
  internalTransferState: InternalTransferState,
  FeatureToggleState: FeatureToggleState,
): string => {
  const isOwner = internalTransferState.triage.isOwner;
  const isAdditionalSignerFlow: boolean = internalTransferState.transferId !== null;
  const isToFromToggleOn: boolean = FeatureToggleState.to_from_consolidation;
  const routes = {
    differentOwners: 'secure/internal-transfer/different-owner-recipient',
    openAccount: 'secure/internal-transfer/open-account',
    transferTo: 'secure/internal-transfer/transfer-to',
    reviewPage: `secure/internal-transfer/review-multisigner`,
    personalInfo: 'secure/internal-transfer/personal-info',
    review: 'secure/internal-transfer/review',
  };

  if (isAdditionalSignerFlow) {
    return routes.reviewPage;
  } else if (!isOwner) {
    return routes.differentOwners;
  } else if (!eligibleInternalTransferToAccounts.accounts.length) {
    return routes.openAccount;
  } else if (isToFromToggleOn) {
    return internalTransferState.transactionType === TransactionTypesEnum.NEW_ACCOUNT
      ? routes.personalInfo
      : routes.review;
  } else {
    return routes.transferTo;
  }
};

export const getInternalTransferDifferentOwnersNextPage = (): string =>
  'secure/internal-transfer/review';

export const getInternalTransferOpenAccountNextPage = (
  internalTransfer: InternalTransferState,
): string => {
  return internalTransfer.transactionType === TransactionTypesEnum.NEW_ACCOUNT
    ? 'secure/internal-transfer/personal-info'
    : 'internal-transfer/ineligible';
};
export const getInternalTransferPersonalInfoNextPage = (): string =>
  'secure/internal-transfer/contact-info';
export const getInternalTransferContactInfoNextPage = (settlementFundToggle: boolean): string =>
  settlementFundToggle
    ? 'secure/internal-transfer/settlement-fund'
    : 'secure/internal-transfer/employment';
export const getInternalTransferSettlementFundNextPage = (): string =>
  'secure/internal-transfer/employment';
export const getInternalTransferEmploymentNextPage = (): string =>
  'secure/internal-transfer/income-net-worth';
export const getInternalTransferIncomeNetWorthNextPage = (): string =>
  'secure/internal-transfer/investment-objectives';
export const getInternalTransferInvestObjNextPage = (): string => 'secure/internal-transfer/review';
export const getInternalTransferReviewNextPage = (
  internalTransfer: InternalTransferState,
): string => {
  const isAdditionalSignerFlow: boolean = internalTransfer.transferId !== null;

  if (isAdditionalSignerFlow) {
    return `secure/internal-transfer/terms/existing-multisigner`;
  }
  if (internalTransfer.transferFrom.hasAvgCostHoldings) {
    return 'secure/internal-transfer/cost-basis-opt-in';
  }
  if (internalTransfer.transactionType === TransactionTypesEnum.NEW_ACCOUNT) {
    return 'secure/internal-transfer/terms/new';
  }
  return 'secure/internal-transfer/terms/existing';
};
export const getInternalTransferCostBasisOptInNextPage = (
  internalTransfer: InternalTransferState,
): string =>
  internalTransfer.transactionType === TransactionTypesEnum.NEW_ACCOUNT
    ? 'secure/internal-transfer/terms/new'
    : 'secure/internal-transfer/terms/existing';
export const getInternalTransferTermsExistingNextPage = (
  internalTransferState: InternalTransferState,
): string => {
  const isAdditionalSignerFlow: boolean = internalTransferState.transferId !== null;

  return isAdditionalSignerFlow
    ? `secure/internal-transfer/confirm-multisigner`
    : 'secure/internal-transfer/confirm';
};
export const getInternalTransferTermsNewNextPage = (): string => 'secure/internal-transfer/confirm';

export const getDivorceDocUploadNextPage = (): string => 'secure/divorce/holdings-review';

export const getDivorceReviewHoldingsNextPage = (): string => 'secure/divorce/review';

export const getDivorceReviewNextPage = (): string => 'secure/divorce/terms/divorce-existing';

export const getDivorceTermsNextPage = (): string => 'secure/divorce/confirm';
